var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"modalClasses":"Dialog modal-xl","loading":_vm.loading},on:{"close":function($event){return _vm.$emit('close')}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"title title-up"},[_vm._v(_vm._s(_vm.title))])]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }